/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserOptionalReductionRequisitionId } from './userOptionalReductionRequisitionId';


/**
 * (tsType: @loopback/repository-json-schema#Optional<Omit<ReductionRequisitionStatusHistory, \'id\'>, \'reductionRequisitionId\'>, schemaOptions: { title: \'NewReductionRequisitionStatusHistoryInPersonalReductionRequisition\', exclude: [ \'id\' ], optional: [ \'reductionRequisitionId\' ] })
 */
export interface NewReductionRequisitionStatusHistoryInPersonalReductionRequisition { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    comments?: string;
    statusId?: string;
    reductionRequisitionId?: string;
    changedBy?: UserOptionalReductionRequisitionId;
}

